import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown
} from "reactstrap";

import { withTranslation } from "react-i18next";
import { getAllEvents, getBookingByEventId, getTicketTypesBySlugId } from "api";
import Breadcrumbs from "components/Common/Breadcrumb";
import Select from "react-select";
import moment from "moment";
import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import jsPDF from "jspdf";
import "jspdf-autotable";

const pagination = true;
const paginationPageSize = 500;
const paginationPageSizeSelector = [200, 500, 1000];

const BookingStatus = (props) => {
  document.title = "Booking List | EventoX";
  const [eventList, setEventList] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [bookingList, setBookingList] = useState([]);
  const [reports, setReports] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [reports2, setReports2] = useState([
    { title: "Total Collected Amount", iconClass: "bx-copy-alt", description: 0,col:3 },
    { title: "Total Ticket Sales", iconClass: "bx-copy-alt", description: 0,col:3 },
    { title: "Total Discount", iconClass: "bx-copy-alt", description: 0,col:3 },
    { title: "Total Booking", iconClass: "bx-archive-in", description: 0,col:3 },



    { title: "Organizer Revenue", iconClass: "bx-purchase-tag-alt", description: 0, col:4},
    { title: "Eventox Revenue", iconClass: "bx-purchase-tag-alt", description: 0, col:4},
    { title: "Strip Payment Fee", iconClass: "bx-purchase-tag-alt", description: 0, col:4},



    


])

  useEffect(() => {
    fetchAllEvents();
  }, []);

  useEffect(() => {
    if (selectedEvent) {
      fetchBookingByEvent(selectedEvent);
    }
  }, [fromDate, toDate, selectedEvent]);
  
  const fetchAllEvents = async () => {
    try {
      const respAllEvent = await getAllEvents();
      const eventOptions = respAllEvent.map((item) => {
        return {
          value: item.eventId,
          label: item.eventName,
          slugId: item.slugId
        }
      });
      setEventList(eventOptions);
    } catch (error) {
      console.log("Error fetching events:", error);
    }
  };

  const fetchBookingByEvent = async (eventObj) => {
    try {
      const { value: eventId, slugId } = eventObj;
      const getBookingResp = await getBookingByEventId(eventId);
      const activeBooking = getBookingResp.filter((item) => item.bookingStatus === 'confirmed' );
      const filteredBooking = activeBooking.filter((item) => {
        const bookingDate = moment(item.createdAt);
        const from = fromDate ? moment(fromDate).startOf("day") : null;
        const to = toDate ? moment(toDate).endOf("day") : null;
        return (!from || bookingDate.isSameOrAfter(from)) &&
               (!to || bookingDate.isSameOrBefore(to));
      });
            setBookingList(filteredBooking);
      fetchReports2(getBookingResp);
      const ticketTypes = await getTicketTypesBySlugId(slugId);
      const dynamicReports = ticketTypes.map((ticket) => {
        const groupPart = ticket.groupName ? ticket.groupName + ' → ' : '';
        return {
          title: `${groupPart}  ${ticket.ticketType} ${ticket.venueId!==null ? `(${ticket['Venue.venueName']})` : ''}`,
          description: 'Tickets Sold: ' + ticket.totalTicketsSold,
          price: 'Price: $' + ticket.price,
          totalTicketAmount: 'Total Ticket Amount: $' + (parseFloat(ticket.price)*parseInt(ticket.totalTicketsSold).toFixed(2) || 0),
          type:'ticket-details'
        }
      });
      setReports(dynamicReports);
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  const fetchReports2 = async (getBookingResp) => {
        let totalEventoxFee=0;
        let totalStripeFee=0;   
        let totalTicketAmount=0;
        let totalDiscountAmount=0;
        let totalTicketSold=0;
        let totalGrandTotal=0;
        let totalSuccessBooking=0;
        let totalOrganizerRevenue = 0; 
       
        
        getBookingResp.forEach(item => {
            if(item.bookedBy === '0'&&item.bookingStatus === 'confirmed'){
               
                console.log("🚀 ~ getBookingResp.forEach ~ item:", item)
                const grandTotal = item.grandTotal;
                const ticketAmount = item.totalTicketAmount;
                const discountAmount = item.discountAmount?item.discountAmount:0;
                const stripefee=item.stripeRevenue 
                const eventoxRevenue=item.eventoxRevenue
                const organizerRevenue = item.organizerRevenue 
                totalStripeFee += stripefee;
                totalEventoxFee+=eventoxRevenue;
                totalTicketAmount+=ticketAmount;
                totalDiscountAmount+=discountAmount;
                totalTicketSold += item?.totalTicketCount || 0;
                totalTicketSold+=item?.totalTicketCount;
                totalGrandTotal+=item.grandTotal;
                totalSuccessBooking+=1;
                totalOrganizerRevenue += Number(organizerRevenue);


                
            }
        })
        



        setReports2([
            { title: "Total Collected Amount", iconClass: "bx-copy-alt", description: `$${totalGrandTotal.toFixed(2)}`,col:3 },
            { title: "Total Discount", iconClass: "bx-copy-alt", description: `$${totalDiscountAmount.toFixed(2)}`,col:3 },
            { title: "Total Success Booking", iconClass: "bx-archive-in", description: totalSuccessBooking,col:3 },


            { title: "Organizer Revenue", iconClass: "bx-purchase-tag-alt", description: `$${totalOrganizerRevenue.toFixed(2)}`, col: 4 },
            { title: "Eventox Revenue", iconClass: "bx-purchase-tag-alt", description: `$${totalEventoxFee.toFixed(2)}`, col:4},
            { title: "Strip Payment Fee", iconClass: "bx-purchase-tag-alt", description: `$${totalStripeFee.toFixed(2)}`, col:4},
            


           

        ])
  }

  const columns = useMemo(() => [
    {
      headerName: 'Booking No',
      field: 'bookingNo',
      filter: true
    },
    {
      headerName: 'Name',
      valueGetter: params => {
        const contact = params.data.bookingObject?.primaryContactDetails || {};
        return `${contact.firstName || ''} ${contact.lastName || ''}`;
      },
      filter: true
    },
    {
      headerName: 'Email',
      field: 'Contact.email',
     
      filter: true
    },
    {
      headerName: 'Ticket Type',
      field: 'TicketType.ticketType',
     
      filter: true
    },
    {
      headerName: 'Ticket Count',
      valueGetter: params => params.data.bookedBy === "0" ? params.data.totalTicketCount || '' : '',
      filter: true
    },
    {
      headerName: 'Ticket Amount',
      field: 'totalTicketAmount',
      filter: true
    },
    {
      headerName: 'Discount Amount',
      field: 'discountAmount',
      filter: true
    },
    
    {
      headerName: 'Grand Total',
      field: 'grandTotal',
      filter: true
    },
    {
      headerName: 'Booking Date',
      cellRenderer: params => {
        return moment(params.data.createdAt).format('DD-MMM-YYYY HH:mm:ss');
      }
    },
  ]);

  const sideBar = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
      },
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
      },
    ],
    defaultToolPanel: 'filters',
  };

  const downloadCSV = () => {
    if (bookingList.length === 0 && reports2.length === 0) return;
  
    const csvRows = [];
  
    // --- First Table: Booking List ---
    if (bookingList.length > 0) {
      const headers1 = [
        "Booking No",
        "Name",
        "Email",
        "Phone",
        "Ticket Type",
        "Ticket Count",
        "Ticket Amount",
        "Discount Amount",
        "Grand Total",
        "Booking Date"
      ];
      csvRows.push(headers1.join(","));
  
      for (const item of bookingList) {
        const row = [
          item.bookingNo,
          item?.Contact?.firstName + " " + item?.Contact?.lastName,
          item?.Contact?.email,
          item?.Contact?.phoneNo,
          item?.TicketType?.ticketType,
          item?.totalTicketCount,
          item?.totalTicketAmount,
          item?.discountAmount,
          item?.grandTotal,
          moment(item?.createdAt).format("DD-MMM-YYYY HH:mm:ss")
        ];
        csvRows.push(row.join(","));
      }
    }
  
    // Add blank line
    csvRows.push("");
  
    // --- Second Table: Reports2 ---
    if (reports2.length > 0) {
      const headers2 = ["Title", "Description"];
      csvRows.push(headers2.join(","));
      for (const row of reports2) {
        csvRows.push([row.title, typeof row.description === "string" ? row.description.replace(/,/g, "") : row.description].join(","));
      }
    }
  
    // Create and trigger download
    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", "Booking_Status_reports.csv");
    a.click();
    URL.revokeObjectURL(url);
  };
  
  
  
  const downloadPDF = () => {
  if (bookingList.length === 0 && reports2.length === 0) return;

  const doc = new jsPDF("l", "mm", "a4");

  // --- First table: Booking List ---
  if (bookingList.length > 0) {
    const headers1 = [
      "Booking No",
      "Name",
      "Email",
      "Phone",
      "Ticket Type",
      "Ticket Count",
      "Ticket Amount",
      "Discount Amount",
      "Grand Total",
      "Booking Date"
    ];

    const body1 = bookingList.map(item => [
      item.bookingNo,
      item?.Contact?.firstName + " " + item?.Contact?.lastName,
      item?.Contact?.email || "N/A",
      item?.Contact?.phoneNo,
      item?.TicketType?.ticketType,
      item?.totalTicketCount,
      item?.totalTicketAmount,
      item?.discountAmount,
      item?.grandTotal,
      moment(item?.createdAt).format("DD-MMM-YYYY HH:mm:ss")
    ]);

    doc.autoTable({
      head: [headers1],
      body: body1,
      startY: 10,
    });
  }

  // Add vertical space
  let finalY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 10;

  // --- Second table: Reports2 ---
  if (reports2.length > 0) {
    const headers2 = ["Title", "Description"];
    const body2 = reports2.map(row => [row.title, row.description]);

    doc.autoTable({
      head: [headers2],
      body: body2,
      startY: finalY,
    });
  }

  doc.save("Booking_Status_reports.pdf");
};


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Booking Status Report")}
          />

          <Row>
            <Col xl="12">
              <Row>
                {(reports || [])?.map((report, key) => (
                  <Col md="3" key={"_col_" + key}>
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">
                              {report.title}
                            </p>
                            <h6 className="mb-0 fw-medium">{report.description}</h6>
                            <h6 className="mb-0 fw-medium">{report.price}</h6>
                            <h6 className="mb-0 fw-medium text-danger">{report.totalTicketAmount}</h6>
                          </div>
                         
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
          <Row>
            {(reports2 || [])?.map((report, key) => (
              <Col md="2" key={"_col_" + key}>
                <Card className="mini-stats-wid">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">
                          {report.title}
                        </p>
                        <h6 className="mb-0 fw-medium text-danger">{report.description}</h6>
                        
                      </div>
                     
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>            
                  <Row className="mb-3">
  <Col xl="5">
    <Select
      value={selectedEvent}
      placeholder="Select Event"
      onChange={(data) => {
        setSelectedEvent(data);
        fetchBookingByEvent(data);
      }}
      options={eventList}
      width="100%"
      className="select2-selection"
    />
  </Col>
              <Col xl="2">
                <label>From Date</label>
                <input
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  className="form-control"
                />
              </Col>

              <Col xl="2">
                <label>To Date</label>
                <input
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  className="form-control"
                />
              </Col>
  <Col >
                      <div className="text-lg-end mt-3 mt-lg-0">
                       <UncontrolledDropdown>
                        <DropdownToggle color="primary" type="button">
                          <i className="bx bx-download me-2"></i> Export <i className="mdi mdi-chevron-down"></i>
                          </DropdownToggle>
                          <DropdownMenu>
                          <DropdownItem href="#" onClick={downloadCSV}>Export CSV</DropdownItem>
                          <DropdownItem href="#" onClick={downloadPDF}>Export PDF</DropdownItem>
                          </DropdownMenu>
                          </UncontrolledDropdown>
                          </div>
                          </Col>
</Row>

                  <Row>
                    <div
                      style={{
                        height: '500px',
                        width: '100%'
                      }}
                      className="ag-theme-quartz"
                    >
                      <AgGridReact
                        columnDefs={columns}
                        rowData={bookingList}
                        sideBar={sideBar}
                        rowGroupPanelShow="always"
                        pagination={pagination}
                        paginationPageSize={paginationPageSize}
                        paginationPageSizeSelector={paginationPageSizeSelector}
                      />
                    </div>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(BookingStatus);